import React from "react";
import {
  Alert,
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Input,
  Row,
  Button,
  Col,
  Collapse,
  FormText,
  Form,
} from "reactstrap";
import SipsOption from "./SipsOption";
import Reflux from "reflux";
import { UserStore } from "../../store/UserStore";

export default class SipsFilter extends Reflux.Component {
  formRef: any = null;
  filters = {
  };

  constructor(props) {
    super(props);
    this.state = {
      showFilters: true,
      filters: this.filters,
      userGroupId: 4
    };
    this.store = UserStore;
    this.formRef = React.createRef();
  }

  componentDidMount() {
    // Local storage last filters
    const lastFilters = localStorage.getItem("lastFilters");
    const user = localStorage.getItem("user");

    if(user) {
      const parsedUser = JSON.parse(user);

      this.setState({
        userGroupId: parsedUser.user_group_id
      })
    }
    if (lastFilters) {
      try {
        const parsedFilters: any = JSON.parse(lastFilters) as any;

        this.setState({ filters: parsedFilters }, this.submit);
      } catch (e) {}
    }
  }

  showFiltersToggle = () => {
    const showFilters = !this.state.showFilters;

    this.setState({ showFilters });
  };

  getFilterIcon = () => {
    return this.state.showFilters ? "ni-bold-up" : "ni-bold-down";
  };

  onChangeField = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    const filters = this.state.filters;
    if (name === "cups" || name === "CIF") {
      value = value.split("\n").join(",");
    }
    filters[name] = value;
    if (event.target.type === "select-one" && value === "0") {
      delete filters[name];
    }

    if (value === "" || value === null) {
      delete filters[name];
    }

    this.setState({ filters });
  };

  async setDate(date, key) {
    const filters = this.state.filters;
    filters[key] = date;
    if (key === "startDate") {
      filters["endDate"] = null;
    }

    await this.setState({ filters });
  }

  clearForm = () => {
    //const filters = this.filters; ---> Eliminado porque no cambiaba campos
    const filters = {};
    this.setState({ filters });
    this.formRef.current.reset();
    localStorage.setItem("lastFilters", JSON.stringify(this.state.filters));
  };

  submit = () => {
    localStorage.setItem("lastFilters", JSON.stringify(this.state.filters));
    const keys = Object.keys(this.state.filters).filter((value) => {
      return value !== "perfilPersona";
    });

    if (keys.length > 0) {
      this.props.onSubmit(this.state.filters);
    }
  };

  buildMaxRecordsOptions() {
    if (!this.state.UserStore.hasData) {
      return null;
    }

    //const steps = [10, 20, 50, 100, 200, 500, 1000, 2000, 3000, 4000, 5000];
    const steps = [10, 20, 50, 100, 200, 300, 400,500, 800, 1000];

    return steps.map((value) =>
      this.state.UserStore.data.query_limit >= value ? (
        <option value={value} key={value}>
          {value}
        </option>
      ) : null
    );
  }

  render() {
    const forceUseFields =
      Object.keys(this.state.filters).filter((value) => {
        return value === "codigoTarifaATREnVigor";
      }).length === 1;
    //const forceUseCP =
    //  Object.keys(this.state.filters).filter((value) => {
    //    return value === "codigoPostalPS";
    //  }).length !== 1 && forceUseFields;
    //const forceUseLocality =
    //  Object.keys(this.state.filters).filter((value) => {
    //    return value === "codigoMunicipioPS";
    //  }).length !== 1 && forceUseFields;
    const forceUseAuto =
      Object.keys(this.state.filters).filter((value) => {
        return value === "codigoAutonomiaPS";
      }).length !== 1 && forceUseFields;

    //const infoForceUseFields = forceUseCP || forceUseLocality ? (<Col md="12"><Alert color="warning">
    const infoForceUseFields = forceUseAuto ? (<Col md="12"><Alert color="warning">
      Seleccionar una autonomía es obligatorio por el volumen de datos a tratar. Consulte con nuestro equipo de ventas para cuestiones relativas a grandes volúmenes de datos
    </Alert></Col>) : null;

    let submitDisabled =
      Object.keys(this.state.filters).filter((key) => {
        return key !== "perfilPersona" && key !== "codigoTarifaATREnVigor";
      }).length < 1;

    //if(forceUseCP || forceUseLocality) {
    if(forceUseAuto) {
      submitDisabled = true;
    }
    const lgCols = this.state.userGroupId === 4 ? '6' : '4';
    const enableFilter = this.state.userGroupId === 4 ? 'd-none' : '';

    return (
      <Card className="mb-4">
        <CardHeader>
          <Button
            onClick={this.showFiltersToggle}
            size="sm"
            className="float-right"
          >
            <i className={"ni " + this.getFilterIcon()} />
          </Button>
          <h3 className="mb-0">Filtrar</h3>
        </CardHeader>
        <Collapse isOpen={this.state.showFilters}>
          <CardBody>
            <Form innerRef={this.formRef}>
              <Row>
                {infoForceUseFields}
                <Col md="12" lg={lgCols}>
                  <FormGroup>
                    <Label className="form-control-label" htmlFor="cliente">
                      Nombre cliente
                    </Label>
                    <Input
                      id="cliente"
                      placeholder="Ingresar nombre del cliente"
                      name="nombreCompletoTitular"
                      onChange={this.onChangeField}
                      value={this.state.filters.nombreCompletoTitular}
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12" lg="2" className={enableFilter}>
                  <FormGroup>
                    <Label className="form-control-label" htmlFor="cliente">
                      Tipo
                    </Label>
                    <Input
                      id="perfilPersona"
                      placeholder=""
                      name="perfilPersona"
                      onChange={this.onChangeField}
                      value={this.state.filters.perfilPersona}
                      type="select"
                    >
                      <option value="">Seleccionar...</option>
                      <option value="F">Persona física</option>
                      <option value="J">Persona jurídica</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="12" lg="3" className={enableFilter}>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="codigoEmpresaDistribuidora"
                    >
                      Distribuidora
                    </Label>
                    <SipsOption
                      placeholder="Seleccionar distribuidora"
                      id="codigoEmpresaDistribuidora"
                      name="codigoEmpresaDistribuidora"
                      query="LIST_DEALERS"
                      value={this.state.filters.codigoEmpresaDistribuidora}
                      onChange={this.onChangeField}
                    ></SipsOption>
                  </FormGroup>
                </Col>
                <Col md="12" lg="3" className={enableFilter}>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="example3cols3Input"
                    >
                      Tarifa
                    </Label>
                    <SipsOption
                      placeholder="Seleccionar tarifa"
                      id="codigoTarifaATREnVigor"
                      name="codigoTarifaATREnVigor"
                      query="LIST_RATES"
                      value={this.state.filters.codigoTarifaATREnVigor}
                      onChange={this.onChangeField}
                    ></SipsOption>
                  </FormGroup>
                </Col>
                <Col md="12" lg={lgCols}>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="codigoPostalPS"
                    >
                      Codigo postal
                    </Label>
                    <Input
                      id="codigoPostalPS"
                      name="codigoPostalPS"
                      placeholder="Ingresar código postal"
                      onChange={this.onChangeField}
                      value={this.state.filters.codigoPostalPS}
                      type="text"
//                      invalid={forceUseCP}
                    />
                  </FormGroup>
                </Col>
                <Col md="12" lg="4" className={enableFilter}>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="codigoAutonomiaPS"
                    >
                      Comunidad autonoma
                    </Label>
                    <SipsOption
                      placeholder="Seleccionar comunidad autónoma"
                      id="codigoAutonomiaPS"
                      name="codigoAutonomiaPS"
                      query="LIST_AUTONOMOUS_COMMUNITIES"
                      onChange={this.onChangeField}
                      value={this.state.filters.codigoAutonomiaPS}
                      invalid={forceUseAuto}
                    ></SipsOption>
                  </FormGroup>
                </Col>
                <Col md="12" lg="4" className={enableFilter}>
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="codigoComercializadora"
                    >
                      Comercializadora
                    </Label>
                    <SipsOption
                      placeholder="Seleccionar comercializadora"
                      id="codeComercializadora"
                      name="codeComercializadora"
                      value={this.state.filters.codeComercializadora}
                      query="LIST_MARKETERS"
                      onChange={this.onChangeField}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm="12"></Col>
                <Col md="6" sm="12" lg="6">
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="example5cols3Input"
                    >
                      CUPS
                    </Label>
                    <Input
                      id="cups"
                      name="cups"
                      type="textarea"
                      style={{
                        resize: "none"
                      }}
                      value={this.state.filters.cups}
                      onChange={this.onChangeField}
                    ></Input>
                    <FormText color="muted">
                      Para seleccionar multiples escribir id del cup y
                      presionar enter
                    </FormText>
                  </FormGroup>
                </Col>
                <Col md="6" sm="12" lg="6">
                  <FormGroup>
                    <Label
                      className="form-control-label"
                      htmlFor="example5cols3Input"
                    >
                      CIF Cliente:
                    </Label>
                    <Input
                      id="CIF"
                      name="CIF"
                      type="textarea"
                      style={{
                        resize: "none"
                      }}
                      onChange={this.onChangeField}
                      value={this.state.filters.CIF}
                    ></Input>
                    <FormText color="muted">
                      Para seleccionar multiples CIF escribir id y
                      presionar enter
                    </FormText>
                  </FormGroup>
                </Col>
              </Row>
              <Row className={enableFilter}>
                <Col md="6" sm="12" lg="6">
                  <FormGroup>
                    <Label className="form-control-label">
                      Dirección Cliente:
                    </Label>
                    <Input
                      id="direccion_ps"
                      name="direccion_ps"
                      type="text"
                      onChange={this.onChangeField}
                      value={this.state.filters.direccion_ps}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" sm="12" lg="6">
                  <FormGroup>
                    <Label className="form-control-label">
                      Localidad cliente:
                    </Label>
                    <SipsOption
                      placeholder="Seleccionar localidad"
//                     invalid={forceUseLocality}
                      id="codigoMunicipioPS"
                      name="codigoMunicipioPS"
                      query="LIST_LOCALITIES"
                      onChange={this.onChangeField}
                      value={this.state.filters.codigoMunicipioPS}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className={enableFilter}>
                <Col md="12" lg="6">
                  <FormGroup>
                    <Label className="form-control-label">
                      Filtro por Penalización
                    </Label>
                    <Input
                      id="idProblem"
                      placeholder=""
                      name="idProblem"
                      onChange={this.onChangeField}
                      value={this.state.filters.idProblem}
                      type="select"
                    >
                      <option value="">Seleccionar...</option>
                      <option value="">Ningún problema</option>
                      <option value="1">Problema en Reactiva</option>
                      <option value="2">Problema en Potencia</option>
                      <option value="3">Problema en reactiva y potencia</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md="6" sm="12" lg="6">
                  <FormGroup>
                    <Label className="form-control-label">
                      Cantidad de registros:
                    </Label>
                    <Input
                      id="limit"
                      name="limit"
                      type="select"
                      onChange={this.onChangeField}
                      value={this.state.filters.limit}
                    >
                      {this.buildMaxRecordsOptions()}
                    </Input>
                  </FormGroup>
                </Col>

              </Row>
              <Row className={enableFilter}>
                <Col md="12" lg="12">
                  <Label className="form-control-label">
                    Potencia Contratada en Kw
                  </Label>
                </Col>
                <Col md="6" lg="3">
                  <FormGroup>
                    <Label className="form-control-label">Desde</Label>
                    <Input
                      id="consumoPotenciaDesde"
                      name="consumoPotenciaDesde"
                      type="number"
                      onChange={this.onChangeField}
                      min={0}
                      value={this.state.filters.consumoPotenciaDesde}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="3">
                  <FormGroup>
                    <Label className="form-control-label">Hasta</Label>
                    <Input
                      id="consumoPotenciaHasta"
                      name="consumoPotenciaHasta"
                      type="number"
                      onChange={this.onChangeField}
                      min={0}
                      value={this.state.filters.consumoPotenciaHasta}
                    />
                  </FormGroup>
                </Col>
              </Row>


              <Row className={enableFilter}>
                <Col md="12" lg="12">
                  <Label className="form-control-label">
                    Consumo energía anual en Kw
                  </Label>
                </Col>
                <Col md="6" lg="3">
                  <FormGroup>
                    <Label className="form-control-label">Desde</Label>
                    <Input
                      id="consumoDesde"
                      name="consumoDesde"
                      type="number"
                      onChange={this.onChangeField}
                      min={0}
                      value={this.state.filters.consumoDesde}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" lg="3">
                  <FormGroup>
                    <Label className="form-control-label">Hasta</Label>
                    <Input
                      id="consumoHasta"
                      name="consumoHasta"
                      type="number"
                      onChange={this.onChangeField}
                      min={0}
                      value={this.state.filters.consumoHasta}
                    />
                  </FormGroup>
                </Col>
                <Col md="6" sm="12" lg="6" className="text-right">
                  <Button onClick={this.clearForm}>
                    <i className={"ni ni-fat-remove"} /> Limpiar
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.submit}
                    disabled={submitDisabled}
                  >
                    <i className={"bi bi-search"}/> Buscar
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}
